import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import useAnimatedCounter from '../../../hooks/useAnimatedCounter';

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
`;

const CounterWrapper = styled.span`
  display: inline-block;
  font-variant-numeric: tabular-nums;
  
  &.animate-pulse {
    animation: ${pulse} 0.3s ease-out;
  }
`;

/**
 * Animated counter component that smoothly animates from 0 to target value
 */
const AnimatedCounter = ({ 
  value, 
  duration = 1000, 
  prefix = '', 
  suffix = '',
  className = '',
  formatter = null 
}) => {
  const animatedValue = useAnimatedCounter(value, duration, true);
  
  const displayValue = formatter 
    ? formatter(animatedValue) 
    : animatedValue.toLocaleString();

  return (
    <CounterWrapper className={className}>
      {prefix}{displayValue}{suffix}
    </CounterWrapper>
  );
};

AnimatedCounter.propTypes = {
  value: PropTypes.number.isRequired,
  duration: PropTypes.number,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  className: PropTypes.string,
  formatter: PropTypes.func
};

export default AnimatedCounter;
